module.exports = __webpack_public_path__ + "img/about.0c6045e5.png";